import { render, staticRenderFns } from "./live-old-detail.vue?vue&type=template&id=494df11c&scoped=true&"
import script from "./live-old-detail.vue?vue&type=script&lang=js&"
export * from "./live-old-detail.vue?vue&type=script&lang=js&"
import style0 from "./live-old-detail.vue?vue&type=style&index=0&id=494df11c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "494df11c",
  null
  
)

export default component.exports